function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const ClosePending = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 126,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 89.208h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.849h185.359m-6.761-51.452v51.452m-46.536-52.103v52.103m-42.418-57.92h51.85M20.589 124.85V78.472h61.92v46.377m13.094-56.006v56.006M9.046 68.843v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216-29.795-19.806-32.543 20.378m-23.684-4.36L52.35 38.173.878 74.946m123.764 50.125V91.147h-17.718v33.924m62.168-23.332h-20.167V81.465h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 104.419c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M177.327 65.62c11.77-5.019 17.359-18.91 12.483-31.027-4.875-12.117-18.368-17.87-30.138-12.852-11.77 5.02-17.36 18.91-12.484 31.028 4.875 12.116 18.369 17.87 30.139 12.851Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M182.792 47.15c1.862-8.124-3.025-16.264-10.916-18.18-7.891-1.918-15.798 3.113-17.66 11.236-1.863 8.124 3.024 16.264 10.915 18.181 7.891 1.917 15.798-3.114 17.661-11.237Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "m160.595 44.804 5.637 5.359 9.057-12.958M153.227 61.483v.015l-8.331 23.575 11.777-7.672 4.229 13.662 7.605-21.506"
}), /*#__PURE__*/React.createElement(Path, {
  d: "m167.753 67.431.754 2.126 7.605 21.506 4.215-13.662 11.778 7.672-8.331-23.575"
}))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5.5h220v125H.5z"
})), /*#__PURE__*/React.createElement(ClipPath, {
  id: "b"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M143.5 18.5h50v74h-50z"
}))));
export default ClosePending;
//# sourceMappingURL=ClosePending.js.map